export default "__VITE_ASSET__AsYiic$3__"